/**
 * Supabase client initialization.
 *
 * Important: This project uses react-scripts (CRA). All environment variables
 * MUST be prefixed with REACT_APP_ to be included in the production build.
 */
import { createClient } from '@supabase/supabase-js';

// react-scripts (CRA) uses process.env and REACT_APP_ prefix
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL ||
    (process.env.REACT_APP_API_URL?.includes('supabase.co') ? process.env.REACT_APP_API_URL : null) ||
    process.env.VITE_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase configuration error:');
    if (!supabaseUrl) console.error('- REACT_APP_SUPABASE_URL is missing. (Note: REACT_APP_API_URL is set to:', process.env.REACT_APP_API_URL, ')');
    if (!supabaseAnonKey) console.error('- REACT_APP_SUPABASE_ANON_KEY is missing.');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');
